module.exports = __webpack_public_path__ + "static/media/Morder pychons.f1fff7b7.png";